interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  const btnBase =
    "flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-sm transition-colors cursor-pointer";

  return (
    <nav aria-label="分页导航" className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className={`${btnBase} border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
      </button>

      {pages.map((p, i) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            aria-current={p === page ? "page" : undefined}
            className={`${btnBase} ${
              p === page
                ? "border-primary-500 bg-primary-500 font-semibold text-background-50"
                : "border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${i}`} className="px-1 text-foreground-400">
            …
          </span>
        ),
      )}

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className={`${btnBase} border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
      </button>
    </nav>
  );
}